import Vue from 'vue';
import layoutBase from '../layout-base.js';
import store from '../../common/js/store/store';
import searchModule from '../../application-vue/search/search-vuex';
store.registerModule('search', searchModule);
window.initVueSearch = () => {
	new Vue({
		extends: layoutBase,
		el: '#vue-search'
	});
};
window.initVueSearchResult = () => {
	new Vue({
		extends: layoutBase,
		el: '#vue-search-result'
	});
};
